import React from 'react'
import { Container, Icon, Menu } from 'semantic-ui-react'
import { parseQueryString, buildQueryString } from 'utils/functions'
import css from './Header.module.sass'

const publicPath = process.env.PUBLIC_URL

function getParams () {
  const { mode } = parseQueryString()
  let params = `?${buildQueryString()}`

  if (mode) {
    params += `&mode=${mode}`
  }

  return params
}

function MediaHeader () {
  const params = getParams()

  return (
    <Container fluid className={css.wrapper}>
      <Menu>
        <Menu.Item header>
          <Icon link name='film' />
        </Menu.Item>
        <Menu.Item>
          <a href={`${publicPath}/index.html${params}`}>Медиа-редактор</a>
        </Menu.Item>
        <Menu.Item>
          <a href={`${publicPath}/upload.html${params}`}>Загрузка контента</a>
        </Menu.Item>
      </Menu>
    </Container>
  )
}

export default MediaHeader



// WEBPACK FOOTER //
// ./src/components/Header/Header.js